export const buildEventShareUrl = (eventId: number, origin: string = window.location.origin): string => {
  return new URL(`/event/${eventId}`, origin).toString();
};

export const buildEventShareData = (shareUrl: string): ShareData => ({
  url: shareUrl
});

export const shouldUseNativeShare = (deviceNavigator: Navigator = navigator): boolean => {
  if (typeof deviceNavigator.share !== 'function') {
    return false;
  }

  const userAgent = deviceNavigator.userAgent || '';
  const isMobileUserAgent = /Android|iPhone|iPad|iPod/i.test(userAgent);
  const isIPadUsingDesktopMode = /Macintosh/i.test(userAgent) && deviceNavigator.maxTouchPoints > 1;
  return isMobileUserAgent || isIPadUsingDesktopMode;
};

export const copyEventShareUrl = async (shareUrl: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(shareUrl);
      return;
    } catch (error) {
      // Clipboard API access can be denied even when the method exists.
      // Fall through to the legacy copy command for those browsers.
    }
  }

  const textArea = document.createElement('textarea');
  textArea.value = shareUrl;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();

  let copied = false;
  try {
    copied = typeof document.execCommand === 'function' && document.execCommand('copy');
  } finally {
    document.body.removeChild(textArea);
  }

  if (!copied) {
    throw new Error('Unable to copy event link');
  }
};
